import { Controller } from "@hotwired/stimulus"

// Splits text into characters and animates them in as a wave (bottom to top, left to right).
// Triggered via IntersectionObserver on load, or by dispatching "wave-text:play" on the element.

export default class extends Controller {
  static values = {
    delay:    { type: Number, default: 60 },   // ms stagger between chars
    duration: { type: Number, default: 700 }   // animation duration per char
  }

  connect() {
    this.charSpans = []
    this.splitChars()
    this.element.addEventListener("wave-text:play", () => this.play())

    // Trigger on viewport entry only if already visible (first item)
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const item = this.element.closest(".cube-text-item")
          if (!item || item.classList.contains("cube-text-active")) {
            this.play()
          }
          this.observer.unobserve(this.element)
        }
      })
    }, { threshold: 0.1, rootMargin: "0px 0px -40px 0px" })

    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  splitChars() {
    const text = this.element.textContent.trim()
    this.element.innerHTML = ""
    this.charSpans = []

    ;[...text].forEach((char, i) => {
      const span = document.createElement("span")
      span.className = "wave-char"
      span.textContent = char === " " ? "\u00A0" : char
      span.style.animationDelay    = `${i * this.delayValue}ms`
      span.style.animationDuration = `${this.durationValue}ms`
      this.element.appendChild(span)
      this.charSpans.push(span)
    })
  }

  play() {
    // Remove class first, then re-add in next frames to restart animation
    this.charSpans.forEach(s => s.classList.remove("wave-char-visible"))
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.charSpans.forEach(s => s.classList.add("wave-char-visible"))
      })
    })
  }
}
